import { default as LogoColor, default as LogoWhite } from "assets/images/brands/DIGITALK-LOGO-BRANCO.png";

export const Wallet = {
  estadao_atendimento: {
    name: "Estadao Atendimento",
    shortname: "estadao_atendimento",
    logo_color: LogoColor,
    logo_white: LogoWhite,
    token: "d7dc552afa34dd4e1027b7593c0596d0",
    color: {
      primary: "#043AFF",
      secondary: "#fff",
      tertiary: "#E4F0FE",
      hover: "#002FD8",
    },
  },
};
 